export default "__VITE_ASSET__dc3f96c9__"